import { ResolvedPos } from 'prosemirror-model'
import { EditorState } from 'prosemirror-state'

const getOffsetFromNodeAbove = ($from: ResolvedPos): number => {
  return $from.depth + 3
}

export const positionOfNodeAbove = (state: EditorState) => {
  const offsetFromNodeAbove = getOffsetFromNodeAbove(state.selection.$from)
  const positionAtStartOfNode = state.selection.$from.pos - state.selection.$from.parentOffset
  let positionOfNodeAbove = positionAtStartOfNode - offsetFromNodeAbove

  if (positionOfNodeAbove < 0) positionOfNodeAbove = 0

  const $potentialPositionAbove = state.doc.resolve(positionOfNodeAbove)
  return $potentialPositionAbove
}
